import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/svg/mp3Icon.svg'
import _imports_1 from '@/assets/imgcaptions/icon_fileXXXXL.svg'
import _imports_2 from '@/assets/imgcaptions/icon_tianjia.svg'
import _imports_3 from '@/assets/aivoice/pic_kongyinpin.svg'


const _hoisted_1 = { class: "pieceBoxStyle" }
const _hoisted_2 = { class: "pieceOneTop" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  src: _imports_0,
  style: {"width":"100%","height":"100%","padding":"1rem"}
}
const _hoisted_6 = ["onDblclick"]
const _hoisted_7 = {
  key: 2,
  class: "inviteBox"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 3,
  class: "inviteBox"
}
const _hoisted_11 = {
  key: 0,
  class: "dataTimesLine"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "imgList" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "pieceOneTitle" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "pieceOneOperate" }
const _hoisted_19 = { class: "operateIcon" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  class: "operateBtn"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 1,
  class: "noDataPage"
}
const _hoisted_29 = {
  key: 0,
  class: "pieceBoxmask"
}
const _hoisted_30 = { class: "piecedelBox" }

import { ref, onMounted, watch,getCurrentInstance,nextTick,onBeforeUnmount} from 'vue'
// 字节数长度
import { fileSizeNum } from '@/components/public-method/file-size'
// 时间处理方法
import { timeInfominute, timedata } from '@/components/public-method/time-method'
import { useRouter } from "vue-router";
import newCaptionApi from "@/api/newCaption/index.ts";
import headPic from '@/assets/aivoice/ico_morentouxiang.svg';
// 引入删除提示
import delbox from "@/components/common/del.vue";
// 引入树形模块
import routTree from "./routTree.vue"
import { useUploadStore } from "@/store/uploadRate";
import FetchRequest from "@/api/FetchRequest";
import Auth from "@/api/Auth";
const multiple=1
    
export default /*@__PURE__*/_defineComponent({
  __name: 'arrangePiece',
  props: {
        size: Number,//放大倍数
        list:Array,
        justUse:Array,
        treeList:Array,
    },
  emits: ['del','reName','showopenFiled','runDataRun','reCatalog'],
  setup(__props, { expose: __expose, emit: __emit }) {

let { proxy } = getCurrentInstance()
const router = useRouter();
// 接口
const uploadStore = useUploadStore();


const token = Auth.getToken();
// 删除提示弹窗
const opendelShow=ref(false)
const delText=ref('删除该项目，且永久不可恢复，确认删除？')

const showIndex=ref(-1)
const showIndexFun=(index:number)=>{
    console.log('======')
    showIndex.value=index
}
    //默认宽度
    const initStyle={
        width:14,
        height:12.6,
        left: 2.5,
        top:0.2,
        topheight:1.6

    }
    const initmultiple=ref(1)//初始倍数
    const amplify=ref(1) //放大倍数
    const props = __props
    const dataList=ref([])
    // 打开字幕编辑页面
    const projectoften=ref([])
    onMounted(()=>{
        console.log('列表数据')
        console.log(props.list)
        dataList.value=JSON.parse(JSON.stringify(props.list))
        if(props.size>0){
            amplify.value=(props.size/30)
            initmultiple.value=(multiple+amplify.value)
        }
        projectoften.value=JSON.parse(localStorage.getItem('projectoften'))||[]
    })
    const stateList=ref([])
    watch(() => props.list, (n, o) => {
        // console.log('动态获取文件')
        abortStream()
        stateList.value=[]
        dataList.value = JSON.parse(JSON.stringify(props.list))
        dataList.value.forEach(item=>{
            if(item.subtitleStatus==2){
                stateList.value.push(item.subtitleId)
            }

        })
        nextTick(()=>{
            // console.log(stateList.value)
            console.log('动态获取文件')
            abortStream()
            if(stateList.value.length>0){

                stateData()
            }
            
        })
    })
    // 动态获取文件处理状态
let reader = null;
let abortController = null;
const showStateList=ref([])
const stateData = async () => {
    // console.log('=======================')
    abortController= new AbortController();
  try {
    const response = await fetch(FetchRequest.getHost() + '/ai/subtitle/sse/progress', {
      method: 'POST',
      headers: {
         'Content-Type': 'application/json' ,
         Authorization: "Bearer " + token,
        },
      body:  JSON.stringify( stateList.value ) ,
      signal: abortController.signal
    });
    
    // 验证响应类型
    if (!response.ok || !response.body) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
     // 创建流处理器
     reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    const CHUNK_SIZE = 500; // 每积累500字符更新一次
    let initNum=0
    let partialLine = '';
    let chunk=''
    // 使用异步循环读取数据
    while (initNum<CHUNK_SIZE) {
      const { done, value } = await reader.read();
      console.log(value)
      if(value==undefined&&stateList.value.length>0){
        setTimeout(()=>{
            abortStream()
            stateData()
        },1000)
        
      }
    //   console.log(done)
      // 流结束处理
      if (done) {
        // 处理最后缓冲区的剩余数据
        if (buffer.length > 0) {
        //   streamText.value += buffer;
          console.log(buffer)
          buffer = '';
        }
        break;
      }

      // 解码并缓冲数据
      
      // 分块更新优化（减少响应式更新频率）
      chunk=decoder.decode(value, { stream: true });
      console.log(chunk)
      let lines=''
      if(chunk.endsWith('data:') ||chunk.startsWith('[')){
        console.log(chunk)
        // console.log('======++++======')
        partialLine+=chunk
      } else{
        // console.log('============')
        // console.log(partialLine+ chunk)
        lines = (partialLine+ chunk).split('\n')
        partialLine=''
      }
      console.log(lines)
      
  
      for (const line of lines) {
          if (line.trim() === '') continue;
          const data = line.replace('data:', '').trim();
            //   console.log(JSON.parse(data))
          if (line.startsWith('data:')) {
              const data = line.replace('data:', '').trim();
              console.log(JSON.parse(data))
            //   let init=JSON.parse(data)
            // showStateList.value=JSON.parse(data)
            showStateList.value=(JSON.parse(data)).filter(it=>it.remainingTime!=undefined  &&it.remainingTime>0)
              console.log( showStateList.value)
            
          }
      }


    }
  }
   catch (error) {
    console.error('流式请求失败:', error);
  } finally {
    abortController = null;
  }
  
};

// 手动终止流
const abortStream = () => {
  if (abortController) {
    abortController.abort();
    abortController = null
    // streamText.value = '';
  }
};

// 组件卸载时自动终止
onBeforeUnmount(abortStream);
    watch(() => props.size, (n, o) =>{
        console.log('放大倍数'+n)
        amplify.value=(n/30)
        initmultiple.value=(multiple+amplify.value)
        console.log(initmultiple.value*initStyle.width)
        
    })
    watch(() => props.list.length, (n, o) =>{
        dataList.value=JSON.parse(JSON.stringify(props.list))
    })
    watch(() => props.justUse, (n, o) =>{
        projectoften.value=JSON.parse(localStorage.getItem('projectoften'))||[]
    })
    const reStatepice=(subtitleId,subtitleStatus)=>{
        console.log(subtitleId)
        dataList.value.filter(item=>item.subtitleId==subtitleId)[0].subtitleStatus=subtitleStatus
    }
    const emit = __emit
    // 查看文件夹
    const openFiled=(item:any)=>{
        console.log(item)
        showIndex.value=-1
        emit('showopenFiled',JSON.stringify(item))
    }
    // 重新识别
const reRunData=(data:any)=>{
    console.log(data)
    emit('runDataRun', data.subtitleId)
    // runDataRun
}
    // 删除
    const delData=ref()
    const delIndex=ref(0)
    const delThis = (data: object, index: number) => {
    console.log(data)
    showIndex.value=-1
    if(data.folderName!=undefined){
        delText.value="删除该目录将会删除目录下所有文件以及目录，且永久不可恢复，确认删除？"
    }else{
        delText.value="删除该项目，且永久不可恢复，确认删除？"
    }
    delData.value=data
    delIndex.value=index
    opendelShow.value=true
    // emit('del', [data, index])
}
const recognition=()=>{
    opendelShow.value=false
    emit('del', [delData.value, delIndex.value])
}
    // const delThis=(data:object,index:number)=>{
    //     console.log(data)
    //     showIndex.value=-1
    //     emit('del',[data,index])
    // }
    // 重命名
    const editName=(data:object,index:number)=>{
        editIndex.value=-1
        emit('reName',[data,index])
    }
    // 删除文件
    const delOne=(subtitleId:string)=>{
        newCaptionApi.delText(subtitleId).tnen((res)=>{
            console.log(res)
        })
    }
    // 删除文件夹
    const delFolderOne=(id:string)=>{
        newCaptionApi.delFolder(id).tnen((res)=>{
            console.log(res)
        })
    }
    // 文件重命名
    const editIndex=ref(-1)
    const editIndexfun=(index:number)=>{
        editIndex.value=index
    }
    const editOne=(id:string,parentId:number,title:string)=>{
        newCaptionApi.putOne(id,parentId,title).then((res)=>{
            console.log(res)
        })
    }
    // 文件夹重命名
    const editFolderOne=(id:string,parentId:number,folderName:string)=>{
        newCaptionApi.putFolderOne(id,parentId,folderName).then((res)=>{
            console.log(res)
        })
    }
    const textTypeList=[
    {
        subtitleType:0,
        text:'等待处理中'
    },
    {
        subtitleType:1,
        text:'音视频上传中'
    },
    {
        subtitleType:-1,
        text:'音视频上传失败'
    },
    {
        subtitleType:2,
        text:'音视频转码中'
    },
    {
        subtitleType:-2,
        text:'音视频转码失败'
    },
    {
        subtitleType:3,
        text:'AI识别字幕中'
    },
    {
        subtitleType:-3,
        text:'AI识别字幕失败'
    },
    { subtitleType: 30, text: '等待AI识别字幕 ' },
    {
        subtitleType:-4,
        text:'SRT解码错误'
    },
    {
        subtitleType:100,
        text:'AI识别完成'
    },
]
//  0.等待处理 1.音视频转码中 -1.转码失败 9.无字幕 10.人工字幕  20.AI字幕识别中 21.AI字幕 -20.识别失败
    
    const openEdit=(data:any)=>{
        console.log('存储页面常编辑视频')
        console.log(data)
        if(data.subtitleStatus==-3  || data.subtitleStatus!=100){
            return
        }
        // 存储页面常编辑视频
        if(projectoften.value.length!=0){
            const oftennum=projectoften.value.filter(item=>item.subtitleId==data.subtitleId)
            console.log(oftennum)
             if(projectoften.value.length<10 && oftennum.length==0){
                projectoften.value.unshift(data)
                localStorage.setItem('projectoften', JSON.stringify(projectoften.value))
            }else if(projectoften.value.length==10){
                projectoften.value.unshift(data)
                projectoften.value.pop()
                localStorage.setItem('projectoften', JSON.stringify(projectoften.value))
            }
        }else{
            projectoften.value.push(data)
            localStorage.setItem('projectoften', JSON.stringify(projectoften.value))
        }
        nextTick(()=>{
            router.push({ path: '/index/aiApply/captionsEdit', query: { subtitleId: data.subtitleId } })
        })
        
        // 
    }
    // 接受邀请
    const okShare=(subtitleId:string)=>{
        newCaptionApi.sharePut(subtitleId).then((res)=>{
            console.log(res)
            // shareStatus
            dataList.value.filter(item=>item.subtitleId==subtitleId)[0].shareStatus='1'
        })
    }
    const onShare=(subtitleId:string,index:number)=>{
        newCaptionApi.cancelsharePut(subtitleId).then((res)=>{
            console.log(res)
            dataList.value.splice(index,1)
        })
    }
    // 更改目录
const treeListShow=ref(-1)
const treeListStyle=ref({
    top:'2rem',
    left:'-3rem'
})
const subtitleId=ref('')
const editCatalog=(data:any,index:number)=>{
    console.log(data)
    subtitleId.value=data.subtitleId
    treeListShow.value=index
    showIndex.value=-1
    // emit('reCatalog')
}
const showParentRout=(data:any)=>{
        console.log(data)
        newCaptionApi.putInitOneCatalog(subtitleId.value,data[1]).then(res=>{
            console.log(res)
            treeListShow.value=-1
            emit('reCatalog')
        })
        // emit('reCatalog')
}
    __expose({
        reStatepice,
    })

return (_ctx: any,_cache: any) => {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (dataList.value.length > 0)
      ? (_openBlock(), _createBlock(_component_el_scrollbar, { key: 0 }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "pieceList",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (showIndex.value=-1), ["stop"]))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "pieceOne",
                  key: index,
                  style: _normalizeStyle({width:initmultiple.value*initStyle.width+'rem',height:initmultiple.value*initStyle.height+'rem'})
                }, [
                  _createElementVNode("div", _hoisted_2, [
                    (item.type==0)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "pieceOneTopOnly",
                          onClick: _withModifiers(($event: any) => (openEdit(item)), ["stop"])
                        }, [
                          (item.snapshot!=undefined)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _unref(proxy).getimgUrl + '/' +item.snapshot,
                                alt: ""
                              }, null, 8, _hoisted_4))
                            : _createCommentVNode("", true),
                          (item.snapshot==undefined)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_3))
                      : _createCommentVNode("", true),
                    (item.type==1)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "pieceOneTopFolder",
                          onDblclick: _withModifiers(($event: any) => (openFiled(item)), ["stop"])
                        }, _cache[4] || (_cache[4] = [
                          _createElementVNode("img", {
                            src: _imports_1,
                            alt: ""
                          }, null, -1)
                        ]), 40, _hoisted_6))
                      : _createCommentVNode("", true),
                    (!item.isMine && item.shareStatus==0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createElementVNode("span", {
                            class: "inviteOk",
                            onClick: _withModifiers(($event: any) => (okShare(item.subtitleId)), ["stop"])
                          }, "接受邀请", 8, _hoisted_8),
                          _createElementVNode("span", {
                            class: "inviteNo",
                            onClick: _withModifiers(($event: any) => (onShare(item.subtitleId,index)), ["stop"])
                          }, "拒绝邀请", 8, _hoisted_9)
                        ]))
                      : _createCommentVNode("", true),
                    (item.duration == undefined &&item.type != 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(uploadStore).uploadTasks, ([taskId, task]) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: taskId,
                              class: "progress-item"
                            }, [
                              (taskId==item.subtitleId)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                    _createElementVNode("div", {
                                      class: "dataTimesBar",
                                      style: _normalizeStyle({'width':task.progress+'%'})
                                    }, null, 4)
                                  ]))
                                : _createCommentVNode("", true),
                              (taskId==item.subtitleId)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_unref(fileSizeNum)(task.bytes)), 1))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: "cooperate",
                      style: _normalizeStyle({height:initmultiple.value*initStyle.topheight+'rem',paddingLeft:initmultiple.value*initStyle.left+'rem'})
                    }, [
                      _createElementVNode("div", _hoisted_13, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.people, (it, itindex) => {
                          return (_openBlock(), _createElementBlock("img", {
                            src: it.img,
                            alt: "",
                            key: itindex
                          }, null, 8, _hoisted_14))
                        }), 128))
                      ])
                    ], 4)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    (item.type==0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(item.title), 1))
                      : _createCommentVNode("", true),
                    (item.type==1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(item.folderName), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("img", {
                        src: _imports_2,
                        alt: "",
                        onClick: _withModifiers(($event: any) => (showIndexFun(index)), ["stop"])
                      }, null, 8, _hoisted_20)
                    ]),
                    (showIndex.value==index)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          (item.type==0 && item.isMine &&item.subtitleStatus==100)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "commBtn reName",
                                onClick: _withModifiers(($event: any) => (openEdit(item)), ["stop"])
                              }, "编辑", 8, _hoisted_22))
                            : _createCommentVNode("", true),
                          (!item.isMine && item.shareStatus==1 &&item.subtitleStatus==100)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                class: "commBtn reName",
                                onClick: _withModifiers(($event: any) => (openEdit(item)), ["stop"])
                              }, "编辑", 8, _hoisted_23))
                            : _createCommentVNode("", true),
                          (item.type == 0 &&item.isMine&&item.subtitleStatus==-3)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 2,
                                onClick: ($event: any) => (reRunData(item)),
                                class: "commBtn reName"
                              }, "字幕重新识别", 8, _hoisted_24))
                            : _createCommentVNode("", true),
                          (item.type==1 && item.isMine)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 3,
                                class: "commBtn reName",
                                onClick: _withModifiers(($event: any) => (openFiled(item)), ["stop"])
                              }, "查看文件夹", 8, _hoisted_25))
                            : _createCommentVNode("", true),
                          (item.type == 0 &&item.isMine)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 4,
                                class: "commBtn reName",
                                onClick: _withModifiers(($event: any) => (editCatalog(item,index)), ["stop"])
                              }, "更改目录", 8, _hoisted_26))
                            : _createCommentVNode("", true),
                          (item.isMine)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 5,
                                class: "commBtn delOperate",
                                onClick: _withModifiers(($event: any) => (delThis(item,index)), ["stop"])
                              }, "删除", 8, _hoisted_27))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (treeListShow.value==index)
                      ? (_openBlock(), _createBlock(routTree, {
                          key: 1,
                          data: props.treeList,
                          class: "routTree",
                          onUpparentId: showParentRout,
                          onCloseThis: _cache[0] || (_cache[0] = ($event: any) => (treeListShow.value = -1)),
                          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                          style: _normalizeStyle(treeListShow.value==index?treeListStyle.value:'')
                        }, null, 8, ["data", "style"]))
                      : _createCommentVNode("", true)
                  ])
                ], 4))
              }), 128))
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (dataList.value.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, _cache[5] || (_cache[5] = [
          _createElementVNode("div", { class: "imgBox" }, [
            _createElementVNode("img", { src: _imports_3 }),
            _createElementVNode("div", null, "暂无数据")
          ], -1)
        ])))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      (opendelShow.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createVNode(delbox, {
                text: delText.value,
                onCloseThis: _cache[3] || (_cache[3] = ($event: any) => (opendelShow.value = false)),
                onRecognition: recognition
              }, null, 8, ["text"])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})